import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'department_permission_tag_info';
export const useDepartmentPermissionTagInfoTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => useTranslation('entities', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    groups: {
      title: 'Тег назначен группам:',
    },
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    groups: {
      title: 'Tag assigned to groups:',
    },
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    groups: {
      title: 'Etiqueta asignada a grupos:',
    },
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    groups: {
      title: 'Tag atribuída aos grupos:',
    },
  },
}) as Record<string, unknown>;
